export default {
  // 共通操作フィードバック
  'pages.common.add.success': '作成しました',
  'pages.common.edit.success': '更新しました',
  'pages.common.edit.fail': '更新に失敗しました',
  'pages.common.update.success': '更新しました',
  'pages.common.update.error': '更新に失敗しました',

  // ウェルカムページ
  'pages.welcome.link': 'ようこそ',
  'pages.welcome.alertMessage': 'より高速で強力な頑丈なコンポーネントがリリースされました。',

  // 例外ページ
  'pages.403.subTitle': '申し訳ありませんが、このページへのアクセス権限がありません。',
  'pages.403.buttonText': 'ホームに戻る',
  'pages.404.subTitle': '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.500.subTitle': '申し訳ありませんが、サーバーエラーが発生しました。',
  'pages.500.buttonText': 'ホームに戻る',

};
